import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class PopulationTypePopupComponent extends CommonTab {
    state = {
        populationType: this.props.populationType,
        errors: [],
        validateFields: [
            'placepopulationtypename',
            'placepopulationtypenameeng'
        ]
    };

    changeState(name, e) {
        let temp = this.state.populationType;
        temp[name] = e.value;
        this.setState({populationType: temp});
    }

    render() {
        let {populationType, validateFields, errors} = this.state;
        return (
            <Popup openClose={this.props.close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(populationType, validateFields);
                    }}>
                        <h2>{this.props.button + (this.props.button === 'Add' ? ' New' : '')} Place Population Type</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Place Population Type Name :</td>
                                <td className={errors.indexOf('placepopulationtypename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={populationType.placepopulationtypename}
                                        onChange={(e) => {
                                            this.changeState('placepopulationtypename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('placepopulationtypename') !== -1 ?
                                        <span className="errorText">Please set Place Population Type Name</span> : ''}
                                </td>
                            </tr>
                            <tr>
                                <td>Place Population Type Name Eng :</td>
                                <td className={errors.indexOf('placepopulationtypenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={populationType.placepopulationtypenameeng}
                                        onChange={(e) => {
                                            this.changeState('placepopulationtypenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('placepopulationtypenameeng') !== -1 ?
                                        <span className="errorText">Please set Place Population Type Name Eng</span> : ''}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.populationType.map((item) => {
        if (item.placepopulationtypeid == ownProps.id) {
            content = item;
        }
    });
    return {
        populationType: Object.assign({}, content)
    }
};

const PopulationTypePopup = connect(mapStateToProps)(PopulationTypePopupComponent);

export default PopulationTypePopup;